<template>
  <v-layout style="width: 100%;">
    <span v-if="value > 0" class="value-change" :class="reverse ? 'red--text' : 'green--text'">
      <v-icon :class="reverse ? 'red--text' : 'green--text'">arrow_drop_up</v-icon>
      <span>+{{ value }}</span>{{ sign }}
    </span>
    <span v-else-if="value < 0" class="value-change" :class="reverse ? 'red--text' : 'green--text'">
      <v-icon :class="reverse ? 'red--text' : 'green--text'">arrow_drop_down</v-icon>
      <span>{{ value }}</span>{{ sign }}
    </span>
    <span v-else>{{value || ''}}{{ sign }}</span>
  </v-layout>
</template>

<script>
export default {
  name: 'UpDownValue',
  props: ['value', 'reverse', 'sign'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.value-change {
  margin-left: -10px;
  .v-icon {
    position: relative;
    top: 4px;
    right: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/UpDownValue.vue